import { Caption } from "@/lib/main";
import { CSSProperties } from "react";
import Stars from "./Stars";

type Props = {
  id: string;
  rating: number;
};

export default function Rating({ id, rating }: Props) {
  const styles: CSSProperties = {
    display: "flex",
    alignItems: "flex-start",
    gap: "var(--spacing-xs)",

    background: "var(--color-background-frame)",

    borderRadius: "var(--border-radius-circle)",
    border: "var(--border-width-xs) solid var(--color-border-subtle)",
    padding: "0 var(--spacing-sm)",
  };

  return (
    <div style={styles}>
      <Stars id={id} rating={rating} />
      <Caption>{rating}</Caption>
    </div>
  );
}
